__turbopack_context__.v({
  "accordion": "_5UR3RW_accordion",
  "accordion-detail": "_5UR3RW_accordion-detail",
  "accordion-summary": "_5UR3RW_accordion-summary",
  "accordion-summary-text": "_5UR3RW_accordion-summary-text",
});
